import React from 'react';
import './Stats.css';

const Stats = () => {
  const stats = [
    {
      icon: '🏦',
      value: '$19.4T',
      label: 'Gold Market Cap',
      description: 'Larger than all crypto combined'
    },
    {
      icon: '📊',
      value: '1,136 tons',
      label: 'Central Bank Buying (2024)',
      description: 'Record accumulation continues'
    },
    {
      icon: '🎯',
      value: '$5,000',
      label: 'Price Targets',
      description: 'Top analysts predictions'
    },
    {
      icon: '⚡',
      value: '50+ Years',
      label: 'Gold Outperforming',
      description: 'Since Nixon ended gold standard'
    }
  ];

  return (
    <section className="stats-section">
      <div className="stats-ticker">
        <div className="ticker-content">
          <span>📈 GOLD ATH $4,983 </span>
          <span>📈 UP 30% YTD </span>
          <span>🏦 CENTRAL BANKS BUYING </span>
          <span>💎 SMART MONEY ACCUMULATING </span>
          <span>🚀 $GOLD TO THE MOON </span>
          <span>📈 GOLD ATH $4,983 </span>
          <span>📈 UP 30% YTD </span>
          <span>🏦 CENTRAL BANKS BUYING </span>
          <span>💎 SMART MONEY ACCUMULATING </span>
          <span>🚀 $GOLD TO THE MOON </span>
        </div>
      </div>
      
      <div className="container">
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div className="stat-card" key={index}>
              <span className="stat-icon">{stat.icon}</span>
              <span className="stat-value gold-text">{stat.value}</span>
              <span className="stat-label">{stat.label}</span>
              <span className="stat-description">{stat.description}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
